module.exports = __webpack_public_path__ + "img/titan-logo-full.b5bab7ba.svg";